<template>
<div class="container-main">
	<Header/>
    <component :is="pageComp"></component>
	<div class="cloudy-pg1">
		<img src="@/assets/cloudy.png">
	</div>
</div>
</template>

<script>

import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'


import Header from './components/Header'
import ThemeMixin from '@/libs/mixins/themeMixin.js'


export default {
    mixins: [ThemeMixin],
    data: function () {
        return {
        }
    },
    components: {
        Header,
	},
	created() {
        this.loadComponent()
	},
    methods: {
        loadComponent() {
            const requireComponent = require.context('./', false, /\.vue$/i);
            requireComponent.keys().forEach(fileName => {

                const componentConfig = requireComponent(fileName)
                const componentName = upperFirst(
                    camelCase(
                        fileName.split('/')
                        .pop()
                        .replace(/\.\w+$/, '')
                    )
                )
                
                Vue.component(
                    componentName,
                    componentConfig.default || componentConfig
                )
            })
        }
    },
}
</script>

<style scoped>

img {
    max-width: 100%;
}

.b-toast .toast {
    opacity: 1 !important;
}


.question-description {
    background-color: wheat;
    padding: 20px;
}

.test-question {
    margin-top: 20px;
}

.test-part {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 30px;
}

.test-part-info {
    text-align: left;
    border-bottom: 1px solid #a9a9a9;
    margin-bottom: 20px;
}

.test-question-block {
    text-align: left;
}

h5.part-title {
    font-weight: 700;
    font-size: 1.5rem;
}

.thi-thu-modal .modal-content h5 {
    font-weight: 800;
    color: #f30d59;
    margin-top: 15px;
}

.thi-thu-modal .modal-content span {
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    display: block;
}

.thi-thu-modal .modal-content {
    background-color: transparent;
    position: relative;
    border: none;
}

.thi-thu-modal .modal-content::before {
    content: "";
    background-color: #c90606;
    height: 20px;
    width: 100%;
    border: 2px solid #000;
    border-radius: 0px 0px 15px 15px;
    position: absolute;
    bottom: -8px;
    left: 0;
}

.thi-thu-modal .modal-body {
    border: 2px solid #000;
    border-radius: 15px;
    background-color: #fff;
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.3s ease;
    min-width: 320px;
}

.form-dang-ky {
    margin: 20px 40px;
}

.shadow-custom input {
    background-color: #fff;
    width: 100%;
    border: 2px solid #000;
    border-radius: 15px;
    padding: 5px 20px;
    position: relative;
}

.shadow-custom {
    position: relative;
    margin-bottom: 20px;
}

.submit-button button {
    background-color: #ff9c00;
    width: 100%;
    border-radius: 15px;
    height: 44px;
    border: 2px solid #000;
    position: relative;
    color: #fff;
    font-weight: 800;
    font-size: 1.1rem;
}

.submit-button::before {
    background-color: #d35e00 !important;
}

.shadow-custom::before {
    content: "";
    background-color: #c90606;
    height: 20px;
    width: 100%;
    border: 2px solid #000;
    border-radius: 0px 0px 15px 15px;
    position: absolute;
    bottom: -5px;
    left: 0;
}

.struct-item {
    margin: auto;
    display: flex;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 400px;
    padding: 15px;
    background-color: #f1f0f0;
    border-radius: 20px;
}

.struct-content .desc {
    font-size: 0.9rem;
    color: #3498db;
}

.cau-truc {
    background: #fff;
    padding: 10px;
    border: 2px solid #000;
    border-radius: 20px;
}

.struct-imgae img {
    width: 70px;
}

.struct-content h6.struct-item-title {
    font-weight: 800;
}

.struct-content span {
    display: block;
}

.struct-title h5 {
    font-weight: 800;
    margin-bottom: 0px;
}

.struct-title {
    background-color: #2ecc71;
    border-radius: 20px;
    padding: 10px;
    color: #fff;
}

.test-block .question img {
    max-width: 100%;
    max-height: 400px;
}

.struct-title span {
    font-weight: 600;
    font-size: 1rem;
}

.struct-content {
    text-align: left;
    margin-left: 20px;
}

.mobile {
    display: none;
}

#layout-1 .people-main img {
    position: relative;
    z-index: 2;
}

.people-main {
    position: relative;
}

.people-main::after {
    content: "";
    background-image: url("~@/assets/people-item-left.png");
    width: 262px;
    height: 200px;
    display: block;
    position: absolute;
    top: 30px;
    background-size: cover;
    left: -136px;
}

.option {
    text-align: left;
}

.people-main::before {
    content: "";
    background-image: url("~@/assets/people-item-right.png");
    width: 256px;
    height: 314px;
    display: block;
    position: absolute;
    top: 100px;
    background-size: cover;
    right: -175px;
}

#layout-2 .description {
    margin-bottom: 30px;
}

#layout-2 .description p {
    margin-bottom: 0;
    font-weight: 800;
}

.btn-orange a {
    background-color: #ff9c00 !important;
}

.btn-orange::after {
    background-color: #d35e00 !important;
}

nav a {
    padding: 0px 30px;
}

.btn-center {
    width: fit-content;
    margin: auto;
    margin-top: -50px;
}

.btn-highline {
    position: relative;
}

.cau-truc-bai-thi .btn-highline {
    margin-top: -30px;
}

.btn-highline a {
    position: relative;
    font-weight: 800;
    color: #fff;
    background-color: #ff4757;
    border-radius: 16px;
    padding: 8px 40px;
    border: 2px solid #000;
    font-size: 1.2rem;
    z-index: 3;
}

.btn-highline a:hover {
    color: #fff;
}

.btn-highline::after {
    content: "";
    position: absolute;
    bottom: -5px;
    height: 20px;
    width: 100%;
    background-color: #c90606;
    left: 0;
    z-index: 2;
    border-radius: 0px 0px 15px 15px;
    border: 2px solid #000;
}

.text-highline p {
    color: #103e7d;
    font-weight: 800;
    margin-top: 10px;
    font-size: 1.1rem;
}

#app-main {
    text-align: center;
}

#layout-1 {
    width: 80%;
    margin: auto;
    max-width: 900px;
}

img {
    max-width: 100%;
}

#layout-1 .people-main {
    margin: auto;
    margin-top: -40px;
    width: fit-content;
}

#layout-2 h2 {
    font-weight: 800;
    color: #ff273a;
    font-size: 1.5rem;
}

@media (max-width: 769px) {
    #layout-2 .description p {
        display: inline;
    }

    .form-dang-ky {
        margin: 20px 0px;
    }
}

@media (max-width: 850px) {
    .mobile {
        display: block;
    }

    .pc {
        display: none;
    }
}

span.change-employee {
    color: #ff4757;
    cursor: pointer;
}

span.text-alert.danger {
    color: red;
}

.modal-header .close {
    padding: 1rem;
    margin: -1rem -1rem -1rem auto;
}

[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled),
button:not(:disabled) {
    cursor: pointer;
}


.employees-info {
    text-align: center;
    font-weight: 600;
}

.pause-player {
    text-align: center;
    background-color: #fff;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.timeup-player {
    text-align: center;
    background-color: #fff;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.title {
    font-weight: 800;
    text-align: center;
    color: #ff4757;
    text-shadow: 0px 0px 0px #9619248f;
}

.test-block {
    background-color: #fff;
    padding: 20px;
    margin-bottom: 10px;
}

.test-info {
    background-color: #fff;
    border-radius: 10px;
    padding: 20px;
}

.test-info p {
    margin: 0;
}

.test-block .question {
    margin-bottom: 15px;
    text-align: left
}

.custom-control {
    text-align: left;
    position: relative;
    z-index: 1;
    display: block;
    min-height: 1.5rem;
    padding-left: 1.5rem;
}

.custom-control-inline {
    display: -ms-inline-flexbox;
    display: inline-flex;
    margin-right: 1rem;
}

.custom-control-input {
    position: absolute;
    left: 0px;
    top: 2px;
    z-index: -1;
    width: 1rem;
    height: 1.25rem;
}

.fz-20 {
    font-size: 20px !important;
}
</style>

<!-- .... -->
<style scoped>
html * {
    font-family: 'Nunito', sans-serif;
}

#app {
    overflow-x: hidden;
}

.page1,
.page2,
.page3,
.page4,
.page5,
.page6,
.page7 {
    padding-bottom: 130px;
}

/* .ql-editor {
        padding: 0;
    } */

/* #app{
        overflow: hidden;
    } */

/* .text_answer {
        display: inline-block;
        width: calc(100vw - 114px);
    } */

.text_answer p {
    margin-bottom: 0px;
}

audio.voice {
    max-width: 100%;
}

@media (max-width: 992px) {

    .container-sm,
    .container {
        max-width: unset !important;
    }
}

.btn:focus,
input:focus {
    outline: none;
    box-shadow: none;
}

a {
    text-decoration: none;
    font-weight: 800;
    color: #32388f;
}

.container-main {
    background: url('~@/assets/bg.png');
    min-height: 100vh;
    background-size: contain;
    position: relative;
}

.container-main>.cloudy-pg1 {
    position: absolute;
    bottom: 0;
}

.btn.btn-dark {
    background-color: #919f8b;
    text-transform: uppercase;
    color: #fff;
    font-weight: 900;
    font-size: 40px;
    border-radius: 25px;
    line-height: 45px;
    padding: 5px 35px;
    display: inline-block;
    border: 1px solid #616260;
    box-shadow: 0px 4px 2px #4d5c47, 0px 0px 11px 3px #d5baba5c inset;
}

.button-pg1 {
    position: relative;
    z-index: 2;
}

@media only screen and (min-width: 1024px) and (max-width: 1400px) {
    .container-main {
        height: auto;
        /* padding-bottom: 150px; */
    }

    .btn-custom.btn-success,
    .btn-custom.btn-dark,
    .btn-custom.btn-danger {
        padding: 5px 30px;
        /* font-size: 30px !important; */
    }

    .box_test {
        margin-top: 30px;
        height: auto !important;
        padding-bottom: 30px;
    }
}

@media only screen and (max-width: 768px) {

    .btn-custom.btn-success,
    .btn-custom.btn-dark,
    .btn-custom.btn-danger {
        line-height: 35px;
        padding: 8px 30px;
        font-size: 20px !important;
    }

    .container-main {
        height: auto;
        /* padding-bottom: 50px; */
    }

    ul.content_question {
        padding: 0;
    }

    .item_answer .character_answer {
        margin-right: 10px !important;
    }

    .item_answer {
        padding: 5px 10px !important;
    }
}

.question-block {
    /* margin-bottom: 40px; */
}

.modal .modal-header .close {
    -webkit-transform: translate(8px, -2px);
    transform: translate(8px, -2px);
    padding: .2rem .62rem;
    -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
    box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
    border-radius: .357rem;
    background: #fff;
    opacity: 1;
    -webkit-transition: all .23s ease .1s;
    transition: all .23s ease .1s;
    position: relative;
    margin: -.8rem -1.4rem -.8rem auto;
    text-shadow: 0 1px 0 #fff;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: 1;
    color: #5e5873;
}

.modal-title {
    margin-bottom: 0;
    line-height: 1.5;
    font-size: 1.07rem;
    font-family: inherit;
    font-weight: 500;
    line-height: 1.2;
    color: #5e5873;
}

.modal-header {
    padding: .8rem 1.4rem;
    border-bottom: 1px solid #ebe9f1;
    border-top-left-radius: calc(.358rem - 1px);
    border-top-right-radius: calc(.358rem - 1px);
    background-color: #f8f8f8;
    border-bottom: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.modal-body {
    padding: .8rem 1.4rem;
    font-size: 0.95rem;
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
}

.modal .modal-footer {
    padding: .8rem 1.4rem;
    border-bottom-right-radius: calc(.358rem - 1px);
    border-bottom-left-radius: calc(.358rem - 1px);
    border-top: 1px solid rgba(34, 41, 47, .05);
    font-weight: 400;
    line-height: 1.45;
    color: #6e6b7b;
}

</style>
